module.exports = __webpack_public_path__ + "c491edf93edd97d9aae1a75b9d2dff22.png";